module.exports = __webpack_public_path__ + "static/media/img_19.5aedf69c.JPG";